module.exports = __webpack_public_path__ + "static/media/steam.1c5b1a40.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/about/steam.png
// module id = 1487
// module chunks = 0